import { Controller } from "@hotwired/stimulus";
import OnboardingModalHelper from "../helpers/onboarding_modal_helper";
let timer = "";

// Connects to data-controller="modal"
export default class ModalController extends Controller {
  static targets = ["openModal", "passwordshow", "discardPost", "onboardingContent"];
  static values = { autoOpen: Boolean };

  connect() {
    this.handleBeforeCache = this.beforeCache.bind(this);
    document.addEventListener("turbo:before-cache", this.handleBeforeCache);

    if (this.hasOpenModalTarget) return;

    this.modal = bootstrap.Modal.getOrCreateInstance(this.element);

    if (this.autoOpenValue) {
      this.openModalAndCleanUrl();
    }

    if (this.hasDiscardPostTarget) {
      $(this.discardPostTargets).on(
        "click",
        function (event) {
          this.submitPost(this.element);
        }.bind(this)
      );
    }

    this.element.addEventListener("hidden.bs.modal", this.restoreTwoFactorCheckbox);
  }

  disconnect() {
    this.element.removeEventListener("hidden.bs.modal", this.restoreTwoFactorCheckbox);
    document.removeEventListener("turbo:before-cache", this.handleBeforeCache);
    bootstrap.Modal.getInstance(this.element)?.dispose();
    this.modal = null;
  }

  beforeCache() {
    if (this.element.contains(document.activeElement)) document.activeElement.blur();

    bootstrap.Modal.getInstance(this.element)?.dispose();
    this.element.classList.remove("show");
    this.element.style.display = "none";
    this.element.setAttribute("aria-hidden", "true");
    this.element.removeAttribute("aria-modal");
    this.element.removeAttribute("role");

    for (const backdrop of document.querySelectorAll(".modal-backdrop")) {
      backdrop.remove();
    }
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
  }

  open() {
    requestAnimationFrame(() => this.showModal());
  }

  openModalTargetConnected(element) {
    // this.element.setAttribute("data-action", "")
    requestAnimationFrame(() => this.showModal());
  }

  close(event) {
    if (event.detail.success && !$(event.target).hasClass("no-dismiss")) {
      // Submit-end cleanup can reset the editor after the draft guard's handler.
      // The saved form must be clean before hide.bs.modal checks for a draft.
      event.target.dispatchEvent(new CustomEvent("unsaved-changes:clean"));
      this.closeModal();
    }
  }

  closeGhostModal(e) {
    if (e.currentTarget.classList.contains('dismiss-ghost-reminder')) {
      $("#shareReminderRecipeModal").hide();
      $("#finishGhostModal").hide();
      let backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) {
        backdrop.remove();
      }
    }
  }

  closeModal() {
    bootstrap.Modal.getInstance(this.element)?.hide();
  }

  showModal() {
    if (!this.element.isConnected) return;

    this.modal = bootstrap.Modal.getOrCreateInstance(this.element);
    if (!this.modal._isShown) this.modal.show();
  }

  bindSubmitEnd(event) {
    const form = event.target;

    form.addEventListener("turbo:submit-end", (e) => {
      if (e.detail.success && !form.classList.contains("no-dismiss")) {
        this.closeModal();
      }
    }, { once: true });
  }

  userSearch(e) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      e.preventDefault();
      let form = $(e.target).closest("form");
      form[0].requestSubmit();
    }, 500);
  }

  submitPost(e) {
    let truck_modal = document.getElementById("addPostModal");
    const modal = bootstrap.Modal.getInstance(truck_modal);
    modal.show();

    Swal.fire({
      customClass: {
        popup:
          "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
        htmlContainer: "text-black-paint text-white"
      },
      animation: false,
      title: "Discard",
      text: "This can’t be undone and you’ll lose your draft.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Discard"
    }).then((result) => {
      if (result.isConfirmed) {
        globalThis.location.href = "/posts";
      }
    });
  }

  submitEnd(event) {
    const ele = event.currentTarget;
    if (ele.getAttribute("text")?.length > 0) {
      const textElement = ele.querySelector(".btn-text");
      if (textElement) textElement.innerText = ele.getAttribute("text");
    }

    if (ele.dataset.disableValue === "true") ele.classList.add("disabled");
  }

  refreshFrame() {
    this.element.closest(`#${this.element.dataset.reloadFrame}`).reload();
  }

  formSubmit(event) {
    event.target.form.requestSubmit();
  }

  restoreTwoFactorCheckbox = () => {
    const checkbox = document.getElementById("user_is_2fa");
    if (!checkbox) return;

    checkbox.checked = checkbox.defaultChecked;
  };

  close2faVerify() {
    this.restoreTwoFactorCheckbox();
    this.closeModal();
  }

  openModalAndCleanUrl() {
    const url = new URL(globalThis.location.href);
    url.searchParams.delete("past_login_id");
    globalThis.history.replaceState({}, "", url.pathname + url.search);

    requestAnimationFrame(() => {
      this.showModal();
    });
  }

  onboardingContentTargetConnected(element) {
    this.onboardingModalHelper ||= new OnboardingModalHelper(this);
    this.onboardingModalHelper.connect();
  }

  onboardingContentTargetDisconnected(element) {
    this.onboardingModalHelper?.disconnect();
  }
}
